import { render, staticRenderFns } from "./ControlsAir.vue?vue&type=template&id=15e4012d&scoped=true"
import script from "./ControlsAir.vue?vue&type=script&lang=js"
export * from "./ControlsAir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4012d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e4012d')) {
      api.createRecord('15e4012d', component.options)
    } else {
      api.reload('15e4012d', component.options)
    }
    module.hot.accept("./ControlsAir.vue?vue&type=template&id=15e4012d&scoped=true", function () {
      api.rerender('15e4012d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/ControlsAir.vue"
export default component.exports